import { render, staticRenderFns } from "./PropertyStations.vue?vue&type=template&id=132b4793&"
import script from "./PropertyStations.vue?vue&type=script&lang=ts&"
export * from "./PropertyStations.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyStations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports